import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { interval } from 'rxjs';
import { takeWhile, finalize } from 'rxjs/operators';

@Component({
  selector: 'app-countdown-timer',
  templateUrl: './countdown-timer.component.html',
  styleUrls: ['./countdown-timer.component.scss']
})
export class CountdownTimerComponent implements OnInit {
  remainingTime = 30;
  private alive = true;
  @Output() remainingTimeOutput = new EventEmitter<number>();

  constructor() { }

  ngOnInit(): void {
    interval(1000)
      .pipe(
        takeWhile(() => this.alive),
        finalize(() => this.alive = false)
      )
      .subscribe(() => {
        if (this.remainingTime > 0) {
          this.remainingTime--;
          this.remainingTimeOutput.emit(this.remainingTime);
        }
      });
  }
  resetTimer() {
    this.remainingTime = 14;
    this.remainingTimeOutput.emit(this.remainingTime);
    this.alive = true;
  }
}
